// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/service/candidate_service.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_financial_budget } from "../model/financial/budget_pb";
import { file_proto_model_trip_candidates } from "../model/trip/candidates_pb";
import { file_proto_model_system_errors } from "../model/system/errors_pb";
import { file_proto_model_core_model_path } from "../model/core/model_path_pb";
import { file_proto_model_core_money } from "../model/core/money_pb";
import { file_proto_model_core_paging } from "../model/core/paging_pb";
import { file_proto_model_search_search_result } from "../model/search/search_result_pb";
import { file_proto_model_core_sort } from "../model/core/sort_pb";

/**
 * Describes the file proto/service/candidate_service.proto.
 */
export const file_proto_service_candidate_service = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_field_mask, file_google_protobuf_timestamp, file_proto_model_financial_budget, file_proto_model_trip_candidates, file_proto_model_system_errors, file_proto_model_core_model_path, file_proto_model_core_money, file_proto_model_core_paging, file_proto_model_search_search_result, file_proto_model_core_sort]);

/**
 * Describes the message carmen.CreateCandidatePoolRequest.
 * Use `create(CreateCandidatePoolRequestSchema)` to create a new message.
 */
export const CreateCandidatePoolRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 0);

/**
 * Describes the message carmen.CreateCandidatePoolResponse.
 * Use `create(CreateCandidatePoolResponseSchema)` to create a new message.
 */
export const CreateCandidatePoolResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 1);

/**
 * Describes the message carmen.GetCandidatePoolRequest.
 * Use `create(GetCandidatePoolRequestSchema)` to create a new message.
 */
export const GetCandidatePoolRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 2);

/**
 * Describes the message carmen.GetCandidatePoolResponse.
 * Use `create(GetCandidatePoolResponseSchema)` to create a new message.
 */
export const GetCandidatePoolResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 3);

/**
 * Describes the message carmen.ListCandidatePoolsRequest.
 * Use `create(ListCandidatePoolsRequestSchema)` to create a new message.
 */
export const ListCandidatePoolsRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 4);

/**
 * Describes the message carmen.ListCandidatePoolsResponse.
 * Use `create(ListCandidatePoolsResponseSchema)` to create a new message.
 */
export const ListCandidatePoolsResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 5);

/**
 * Describes the message carmen.UpdateCandidatePoolRequest.
 * Use `create(UpdateCandidatePoolRequestSchema)` to create a new message.
 */
export const UpdateCandidatePoolRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 6);

/**
 * Describes the message carmen.UpdateCandidatePoolResponse.
 * Use `create(UpdateCandidatePoolResponseSchema)` to create a new message.
 */
export const UpdateCandidatePoolResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 7);

/**
 * Describes the message carmen.DeleteCandidatePoolRequest.
 * Use `create(DeleteCandidatePoolRequestSchema)` to create a new message.
 */
export const DeleteCandidatePoolRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 8);

/**
 * Describes the message carmen.DeleteCandidatePoolResponse.
 * Use `create(DeleteCandidatePoolResponseSchema)` to create a new message.
 */
export const DeleteCandidatePoolResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 9);

/**
 * Describes the message carmen.AddCandidateRequest.
 * Use `create(AddCandidateRequestSchema)` to create a new message.
 */
export const AddCandidateRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 10);

/**
 * Describes the message carmen.AddCandidateResponse.
 * Use `create(AddCandidateResponseSchema)` to create a new message.
 */
export const AddCandidateResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 11);

/**
 * Describes the message carmen.UpdateCandidateRequest.
 * Use `create(UpdateCandidateRequestSchema)` to create a new message.
 */
export const UpdateCandidateRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 12);

/**
 * Describes the message carmen.UpdateCandidateResponse.
 * Use `create(UpdateCandidateResponseSchema)` to create a new message.
 */
export const UpdateCandidateResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 13);

/**
 * Describes the message carmen.RemoveCandidateRequest.
 * Use `create(RemoveCandidateRequestSchema)` to create a new message.
 */
export const RemoveCandidateRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 14);

/**
 * Describes the message carmen.RemoveCandidateResponse.
 * Use `create(RemoveCandidateResponseSchema)` to create a new message.
 */
export const RemoveCandidateResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 15);

/**
 * Describes the message carmen.ListCandidatesRequest.
 * Use `create(ListCandidatesRequestSchema)` to create a new message.
 */
export const ListCandidatesRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 16);

/**
 * Describes the message carmen.ListCandidatesResponse.
 * Use `create(ListCandidatesResponseSchema)` to create a new message.
 */
export const ListCandidatesResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 17);

/**
 * Describes the message carmen.GetBudgetImpactRequest.
 * Use `create(GetBudgetImpactRequestSchema)` to create a new message.
 */
export const GetBudgetImpactRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 18);

/**
 * Describes the message carmen.GetBudgetImpactResponse.
 * Use `create(GetBudgetImpactResponseSchema)` to create a new message.
 */
export const GetBudgetImpactResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_candidate_service, 19);

/**
 * Service for managing candidate pools and user rating of search results
 *
 * @generated from service carmen.CandidateService
 */
export const CandidateService = /*@__PURE__*/
  serviceDesc(file_proto_service_candidate_service, 0);

